<script setup lang="ts">
import { ref } from "vue";
import { pb } from "@/pocketbase";
import Heading from "@/components/Heading.vue";
import Success from "@/components/Success.vue";
import router from "@/router";

const user: { email: string, name: string } = pb.authStore.model;
const isMailSent = ref(false);

function resendMail() {
  pb.collection('users').requestVerification(user.email);
  isMailSent.value = true
}

async function reload() {
  await pb.collection('users').authRefresh();
  await router.push('/');
}

pb.collection('users').subscribe(pb.authStore.model.id, (e) => {
  if (e.record?.verified) {
    reload();
  }
});
</script>

<template>
  <Heading>Hey {{ user.name }},</Heading>
  <p>Before you can continue you'll need to verify your email address.</p>
  <p>
    We should have already sent one do you. If not, you can
    <a href="#" class="default-anchor" @click.prevent="resendMail">request a new mail</a>.
  </p>
  <Success v-if="isMailSent">
    <p>Sent a mail to {{ user.email }}.</p>
    <p>Once you have confirmed it you can <a href="#" class="default-anchor" @click.prevent="reload">reload this page</a>.</p>
  </Success>
</template>

